export type ThankYouNavState = {
  bookingId: number;
  value?: number;
  currency?: string;
  paymentPath?: 'stripe' | 'pay_later';
  tripId?: number;
  boatId?: number;
  paymentSucceeded?: boolean;
  paymentIntentId?: string | null;
};

/** Build /thankyou path with query params so refresh survives without router state. */
export const buildThankYouPath = (state: ThankYouNavState): string => {
  const params = new URLSearchParams();
  params.set('bookingId', String(state.bookingId));
  if (state.paymentSucceeded === false) {
    params.set('paymentSucceeded', '0');
  } else {
    params.set('paymentSucceeded', '1');
  }
  if (state.paymentPath) {
    params.set('paymentPath', state.paymentPath);
  }
  if (typeof state.value === 'number' && Number.isFinite(state.value)) {
    params.set('value', String(state.value));
  }
  if (state.currency) {
    params.set('currency', state.currency);
  }
  if (state.tripId) {
    params.set('tripId', String(state.tripId));
  }
  if (state.boatId) {
    params.set('boatId', String(state.boatId));
  }
  if (state.paymentIntentId) {
    params.set('paymentIntentId', state.paymentIntentId);
  }
  return `/thankyou?${params.toString()}`;
};
